<div class="time-elapsed-container">
  <img
    src="/assets/component-icons/clock.svg"
    [alt]="'TIME_ELAPSED.CLOCK_ALT' | translate" />
  <div class="time-elapsed" data-testid="htc-elapsed-time-value">
    {{ time }}
  </div>
</div>
